import { render, staticRenderFns } from "./ContactsInfo.vue?vue&type=template&id=e7c8ec3e&scoped=true"
import script from "./ContactsInfo.vue?vue&type=script&lang=js"
export * from "./ContactsInfo.vue?vue&type=script&lang=js"
import style0 from "./ContactsInfo.vue?vue&type=style&index=0&id=e7c8ec3e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c8ec3e",
  null
  
)

export default component.exports